import { render, staticRenderFns } from "./WorkEditor.vue?vue&type=template&id=1edf5b2d"
import script from "./WorkEditor.vue?vue&type=script&lang=js"
export * from "./WorkEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports